import moment from "moment";
import { regex } from "views/pages/manage/common/constant";

export const getFilterFormFields = (dropdownData, reqForm) => {
  const { businessAreas, terms, refundTypes, refundStatus, cashierOffice } = dropdownData;

  return [
    {
      label: 'Branch',
      type: 'select',
      items: businessAreas,
      formKey: 'businessArea',
      onChange: () => { },
      loading: false,
      isMulti: true,
      placeholder: "Select branch",
      disbabled: false,
      isShowCount: true
    },
    {
      label: 'Cashier Office',
      type: 'select',
      items: cashierOffice,
      formKey: 'cashierOffice',
      onChange: () => { },
      loading: false,
      isMulti: true,
      placeholder: "Select Cashier Office",
      disbabled: false,
      isShowCount: true
    },
    {
      label: 'Term',
      type: 'select',
      items: terms,
      formKey: 'terms',
      onChange: () => { },
      loading: false,
      isMulti: false,
      placeholder: "Select Term",
      disbabled: false,
      isShowCount: true
    },
    {
      label: 'Refund Type',
      type: 'select',
      items: refundTypes,
      formKey: 'refundTypes',
      onChange: () => { },
      loading: false,
      isMulti: true,
      placeholder: "Select Term",
      disbabled: false,
      isShowCount: true
    },
    {
      label: 'Refund status',
      type: 'select',
      items: refundStatus,
      formKey: 'finalStatus',
      onChange: () => { },
      loading: false,
      isMulti: true,
      placeholder: "Select Refund Staus",
      disbabled: false,
      isShowCount: true
    },
    {
      label: 'Refund raised from',
      type: 'date',
      formKey: 'refundRequestDateFrom',
      onChange: () => { },
      placeholder: "Select date",
      disabled: false,
      minDate: '',
      maxDate: moment(new Date()),
    },
    {
      label: 'Refund raised to',
      type: 'date',
      formKey: 'refundRequestDateTo',
      onChange: () => { },
      placeholder: "Select date",
      disabled: false,
      minDate: reqForm?.refundRequestDateFrom,
      maxDate: moment(new Date()),
    },
  ]
}

export const dummyData = [
  {
    id: 1,
    psid: "PS123456",
    refundNumber: "RRN-2025-001",
    studentName: "John Doe",
    fatherName: "Richard Doe",
    businessArea: "BU-101",
    regularCourseId: "RC-2025-09",
    sdCourseId: "SD-101",
    termValue: "Term 1",
    refundAmount: "15000",
    refundType: "RECTIFICATION_REFUND",
    refundRequestDate: "2025-08-10T10:15:00Z",
    approvedOn: "2025-08-11T12:45:00Z",
    status: "Approved",
  },
  {
    id: 2,
    psid: "PS654321",
    refundNumber: "RRN-2025-002",
    studentName: "Jane Smith",
    fatherName: "Michael Smith",
    businessArea: "BU-202",
    regularCourseId: "RC-2025-12",
    sdCourseId: "SD-202",
    termValue: "Term 2",
    refundAmount: "20000",
    refundType: "RECTIFICATION_REFUND",
    refundRequestDate: "2025-08-09T14:30:00Z",
    approvedOn: "2025-08-10T09:00:00Z",
    status: "Pending",
  }
];

export const EMPTY_FILTER_FORM = {
  businessArea: "",
  termValue: "",
  refundType: "",
  paymentMode: '',
  refundRequestDateFrom: "",
  refundRequestDateTo: "",
  refundStatus: "",
  cashierOffice: "",
  //   status: "",
  //   actions: null
};

export const searchInputOptions = [
  {
    label: 'PSID',
    keyName: 'psid',
    placeholder: 'Search by PSID',
    errorMsg: 'Please Enter 11 digit PSID',
    regex: regex.numeric,
    isValidInput: val => val?.length === 11,
    validLength: 11
  },
  {
    label: 'Application Id',
    keyName: 'applicationId',
    placeholder: 'Search by Application Id',
    errorMsg: 'Please Enter a valid application id',
    regex: regex.numeric,
    isValidInput: val => val?.length === 8,
    validLength: 8
  },
{
    label: 'Refund Request Number',
    keyName: 'refundNumber',
    placeholder: 'Search by Refund Request Number',
    errorMsg: 'Please Enter a valid refund request number',
    regex: regex.numeric,
    // isValidInput: val => val?.length === 7,
    // validLength: 7
  },  
// {
//     label: 'Student PO Id',
//     keyName: 'studentPoId',
//     placeholder: 'Search by Student PO Id',
//     regex: regex.numeric,
//   },  
// {
//     label: 'Loan PO Id',
//     keyName: 'loanPoId',
//     placeholder: 'Search by Loan PO Id',
//     regex: regex.numeric,
//   },  
]

export const refundTypeDropdown = [
  { label: 'Rectification Refund', value: 'RECTIFICATION_REFUND' },
  { label: 'Completion Refund', value: 'COMPLETION_REFUND' },
  { label: 'Multitype Refund', value: 'MULTI_TYPE_REFUND' }
]

export const refundStatusList = [
  { label: "Approved", value: "Approved" },
  { label: "Rejected", value: "Rejected" },
  { label: "Expired", value: "Expired" },
  { label: "Initiated", value: "Initiated" },
  { label: "Pending", value: "InProgress" },
  { label: "Completed", value: "Completed" }
];


export const initialForm = {
  businessArea: [],
  terms: '',
  refundTypes: [],
  finalStatus: [],
  paymentMode: [],
  cashierOffice: [],
  refundRequestDateFrom: "",
  refundRequestDateTo: "",}

export const getNextStatus = (previousStatus, approvalAction) => {
  // Map pending states to allowed transitions
  const transitions = {
    L1_PENDING: {
      APPROVE: "L1_APPROVED",
      REJECT: "L1_REJECT",
      RECHECK: "L1_RECHECK",
    },
    L2_PENDING: {
      APPROVE: "L2_APPROVED",
      REJECT: "L2_REJECT",
      RECHECK: "L2_RECHECK",
    },
    L3_PENDING: {
      APPROVE: "L3_APPROVED",
      REJECT: "L3_REJECT",
      RECHECK: "L3_RECHECK",
    },
  };

  // If no valid transition → return previous state (or null)
  return transitions[previousStatus]?.[approvalAction] || previousStatus;
}

export const SUB_REFUND_TYPE_MAPPING = {
  RECTIFICATION_REFUND: 'Rectification',
  COMPLETION_REFUND: "Completion",
  FULL_REFUND: 'Full',
  SECURITY_REFUND: 'Security',
  DISCRETIONARY_REFUND: 'Discretionary'
}

export const REFUND_TYPE_MAPPING = {
  RECTIFICATION_REFUND: 'Rectification Refund',
  COMPLETION_REFUND: "Completion Refund",
  MULTI_TYPE_REFUND: "Multitype Refund"
}
